import { render, staticRenderFns } from "./LaboratoryBindServicePage.vue?vue&type=template&id=543ce7d6&scoped=true"
import script from "./LaboratoryBindServicePage.vue?vue&type=script&lang=js"
export * from "./LaboratoryBindServicePage.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryBindServicePage.vue?vue&type=style&index=0&id=543ce7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543ce7d6",
  null
  
)

export default component.exports